var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M57 114C88.4802 114 114 88.4802 114 57C114 25.5198 88.4802 0 57 0C25.5198 0 0 25.5198 0 57C0 88.4802 25.5198 114 57 114Z",
    fill: "#FDDFCA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3822 41.9552C44.3822 41.9552 42.8431 40.1531 39.3045 42.955C35.7659 45.7569 38.752 61.0556 47.4077 56.0832C56.0765 51.1108 44.3822 41.9552 44.3822 41.9552Z",
    fill: "#FB6B21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1603 31.3654C34.1603 31.3654 34.305 30.7077 35.923 28.0768C37.541 25.4459 35.923 24.8539 34.818 25.3801C34.476 25.5379 34.8574 19.9473 32.1213 19.9473C30.0692 19.9473 29.7666 24.433 29.5299 26.564C29.4115 27.6558 29.3852 29.116 29.4772 31.0497C29.5299 32.865 29.6351 34.7461 29.7535 36.6404L34.226 36.2457C34.0156 33.4043 34.134 31.3786 34.134 31.3786L34.1603 31.3654Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9793 75.5124C68.9793 75.5124 71.7154 78.2617 73.2282 86.4964H78.832C78.5163 81.103 77.6087 74.9073 75.4513 68.9483C74.8199 67.1856 73.7807 65.5807 72.3731 64.3573C65.9274 58.714 58.1794 59.3849 58.1794 59.3849C58.1794 59.3849 57.1534 59.306 55.5617 59.4638C51.7337 58.8587 44.4987 58.0695 40.2103 53.6232C39.3027 52.6893 38.5265 51.4133 37.8557 49.9531C36.093 46.112 35.0801 42.9549 34.5013 38.7586C34.3829 37.8773 34.2908 37.0354 34.2382 36.2461L29.7656 36.6407C30.3313 45.0596 31.5678 51.558 33.1858 55.478C37.882 66.8304 47.3927 73.4734 47.3927 73.4734L47.1165 86.5096H69.2161L68.9661 75.5255L68.9793 75.5124Z",
    fill: "#FCA466",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5113 54.268L62.4981 54.439L62.3008 54.2549L62.5113 54.268Z",
    fill: "#EF6A24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1603 31.3656C34.1603 31.3656 34.305 30.7078 35.923 28.0769C37.541 25.446 35.923 24.8541 34.818 25.3803C33.8709 25.8275 33.1211 27.2877 33.1211 27.2877",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1603 31.3656C34.1603 31.3656 34.305 30.7078 35.923 28.0769C37.541 25.446 35.923 24.8541 34.818 25.3803C33.8709 25.8275 33.1211 27.2877 33.1211 27.2877",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2552 34.652L29.9015 34.9962C28.8513 35.0792 28.0673 35.9978 28.1503 37.048L28.1514 37.0611C28.2344 38.1112 29.153 38.8952 30.2031 38.8122L34.5569 38.4681C35.607 38.385 36.391 37.4664 36.308 36.4163L36.307 36.4032C36.224 35.353 35.3054 34.569 34.2552 34.652Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1505 18.29C75.1505 18.29 84.8059 24.0649 83.6878 35.3383C82.5696 46.6117 74.3217 48.848 59.6676 54.1888C45.0134 59.5426 45.3028 53.2285 45.3028 53.2285L44.4609 47.9667L47.3155 32.5364L75.1505 18.29Z",
    fill: "#FB6B21"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8667 55.2015L63.8273 55.3594L63.6562 55.1357L63.8667 55.2015Z",
    fill: "#EF6A24"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7023 50.4322L71.5264 49.2857L72.8749 43.198L78.0507 44.3445C79.7332 44.7172 80.793 46.3801 80.4203 48.0626C80.0477 49.7451 78.3847 50.8049 76.7023 50.4322Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4956 60.2003L55.4691 53.4695L63.3717 54.6125L62.3982 61.3433C62.0818 63.5305 60.0552 65.045 57.868 64.7287C55.6807 64.4123 54.1662 62.3857 54.4826 60.1985L54.4956 60.2003Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6038 26.4463L47.7493 38.5485C47.7493 38.5485 43.4083 55.8204 59.7462 58.7538C76.0973 61.6873 78.4651 38.7195 78.4651 38.7195L79.3596 27.9064",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6038 26.4463L47.7493 38.5485C47.7493 38.5485 43.4083 55.8204 59.7462 58.7538C76.0973 61.6873 78.4651 38.7195 78.4651 38.7195L79.3596 27.9064",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9266 40.8638C71.9266 40.8638 70.4401 39.1405 67.875 39.0879L71.9266 40.8638Z",
    fill: "#F7E1CB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9266 40.8638C71.9266 40.8638 70.4401 39.1405 67.875 39.0879",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8798 36.6015C58.8798 36.6015 56.6436 35.4571 54.4336 36.2464L58.8798 36.6015Z",
    fill: "#F7E1CB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8798 36.6015C58.8798 36.6015 56.6436 35.4571 54.4336 36.2464",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0998 47.0595C69.0998 47.0595 69.0604 45.6782 67.2582 45.2178C65.7849 44.8363 64.7852 45.8624 64.7852 45.8624",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0508 43.218C54.0508 43.218 54.748 42.021 56.5501 42.4814C58.0235 42.8629 58.4049 44.2309 58.4049 44.2309",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1511 18.2905C70.034 14.1073 50.2101 12.3841 44.4616 28.8141C38.713 45.2441 45.606 47.9539 43.1724 56.0045L47.6713 55.2152C44.0275 45.9676 51.2098 31.8791 60.589 32.6815C69.955 33.484 73.5594 25.9333 73.5594 25.9333C75.2563 22.6841 75.1642 18.2905 75.1642 18.2905H75.1511Z",
    fill: "#FB6B21"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9016 26.3275C71.9016 26.3275 71.5595 35.1805 78.0447 40.7317C78.0447 40.7317 86.9635 22.5522 71.9016 26.3275Z",
    fill: "#FB6B21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1211 45.9288C47.3053 46.2708 47.4368 46.4418 47.4368 46.4418C47.371 45.9683 47.3447 45.5342 47.3184 45.0869C47.2526 45.3632 47.1869 45.6526 47.1211 45.9288Z",
    fill: "#FB6B21"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0813 39.0613C42.7129 40.745 43.7653 42.4025 45.4491 42.784L46.6724 43.0602C46.554 41.9553 46.4883 39.9952 46.7382 36.6934C45.0807 36.3646 43.4496 37.4038 43.0813 39.0744V39.0613Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1272 52.4918L54.7617 49.6768C54.7617 49.6768 55.0511 53.5179 59.5631 54.636C64.0751 55.7542 66.1272 52.4918 66.1272 52.4918Z",
    fill: "white",
    stroke: "#FB6B21",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M51.5002 63.0951C54.039 66.068 57.8801 64.7131 57.8801 64.7131C57.0514 62.6741 58.7615 58.3726 58.7615 58.3726L59.7612 58.7409C59.6691 56.8467 56.4857 55.9522 53.9601 54.5315C51.4476 53.1108 50.4083 47.6385 52.5131 42.8371C54.6046 38.0488 56.1306 35.9704 63.0367 34.5234C69.9428 33.0764 71.9818 28.2093 71.9818 28.2093C71.7845 23.7104 72.4159 19.8956 73.1394 17.1068C66.1149 13.9497 49.6191 14.0681 44.4625 28.8144C42.5288 34.3393 42.0289 38.3119 42.121 41.469C41.3843 41.6269 40.4504 42.0478 39.2928 42.9555C35.7542 45.7574 39.0297 59.9117 47.396 56.0837C47.4617 56.0574 47.5012 56.0179 47.567 55.9785C48.7114 56.3731 50.4215 56.531 52.9866 56.0837C53.5654 56.4915 54.21 56.873 54.9072 57.215L54.6836 58.7804C51.3292 58.6094 50.0663 58.3858 45.0281 57.1098C48.593 58.8593 49.1718 60.4116 51.487 63.1082L51.5002 63.0951Z",
    fill: "#FB6B21"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M49.9869 81.4053C49.6844 76.5119 50.0264 72.0656 47.0403 69.5663C44.0542 67.0669 38.0295 61.3973 33.82 47.6903C30.8339 37.9822 31.2812 26.1169 31.7942 20C30.0447 20.4736 29.7684 24.5646 29.5448 26.5641C29.4264 27.6559 29.4001 29.1161 29.4922 31.0498C29.5316 32.3521 29.5974 33.6939 29.6763 35.0488C28.7424 35.2329 28.0715 36.088 28.1373 37.0614C28.2162 38.0217 28.9923 38.7584 29.9263 38.811C30.5445 46.1775 31.7021 51.8997 33.1754 55.4646C37.8716 66.817 47.3823 73.46 47.3823 73.46L47.1061 86.4961H50.1843C50.0922 84.7729 50.0659 83.0365 49.9606 81.4053H49.9869Z",
    fill: "#FB6B21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M74.6632 84.1289C73.5582 76.8413 68.9805 75.5127 68.9805 75.5127C68.9805 75.5127 71.7298 78.262 73.2425 86.4967H75.0184C74.9132 85.7601 74.7948 84.9708 74.6632 84.1289Z",
    fill: "#FB6B21"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4004 65.5C47.4104 65.5003 38.5012 74.4094 38.501 85.3994C38.501 96.3897 47.4102 105.3 58.4004 105.3C69.3908 105.3 78.3008 96.3898 78.3008 85.3994C78.3005 74.4092 69.3906 65.5 58.4004 65.5Z",
    fill: "#FB6B21",
    stroke: "#FEF5EF",
    strokeWidth: 3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.78 77.51V83.915H65.9V85.94H59.78V92.39H57.605V85.94H51.515V83.915H57.605V77.51H59.78Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModal);
export default __webpack_public_path__ + "static/media/modal.75625bc8bf813813246adea66c9c399d.svg";
export { ForwardRef as ReactComponent };